// eslint-disable-next-line no-undef
const isTest = process.env.NODE_ENV === 'test'
const isServer = typeof window === 'undefined'

const sholdLoadPolyfill = !isTest && !isServer && 'onscrollend' in window === false
if (sholdLoadPolyfill) {
  import('scrollyfills')
}
